if ($('.siteCookies').length) {
    $('.siteCookies .siteCookies__buttonWrap').append($('.siteCookies .siteCookies__links').clone());
}